/*
 * Barra fija de compra Salty (celular y escritorio) — ver snippets/salty-sticky-atc.liquid.
 *
 * - Aparece cuando el botón principal de agregar al carrito quedó arriba,
 *   fuera de la pantalla, y se esconde cuando vuelve a verse.
 * - Muestra el talle elegido y su precio; se actualiza con el evento
 *   "variant:change" que el tema dispara sobre el formulario.
 * - Sin talle elegido, lleva al selector de talle. Talle agotado: botón
 *   deshabilitado.
 * - Para agregar hace click en el botón principal: mismo formulario, misma
 *   llamada al carrito, mismos eventos de Meta y GA4.
 */
(function () {
  'use strict';

  function readJSON(el) {
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  function init(bar) {
    var form = document.getElementById(bar.dataset.form);
    if (!form) return;
    var mainBtn = form.querySelector('button[name="add"]');
    if (!mainBtn) return;

    var variants = readJSON(bar.querySelector('[data-sd-sticky-variants]'));
    var text = readJSON(bar.querySelector('[data-sd-sticky-text]'));
    var sizeEl = bar.querySelector('[data-sd-sticky-size]');
    var priceEl = bar.querySelector('[data-sd-sticky-price]');
    var btn = bar.querySelector('[data-sd-sticky-btn]');
    var btnTxt = bar.querySelector('[data-sd-sticky-btn-txt]');
    var thumbEl = bar.querySelector('[data-sd-sticky-thumb]');
    var picker = document.querySelector('hdt-variant-picker[form="' + bar.dataset.form + '"]');
    var state = 'add';

    /* Sin talle elegido = el input del id está vacío o deshabilitado (modo
       "sin preselección" del tema). */
    function currentId() {
      var input = form.querySelector('input[name="id"]');
      if (!input || input.disabled || !input.value) return null;
      return input.value;
    }

    function render(id) {
      var v = id ? variants[id] : null;
      if (v && v.img && thumbEl && thumbEl.getAttribute('src') !== v.img) {
        thumbEl.removeAttribute('srcset');
        thumbEl.src = v.img;
      }
      if (!v) {
        state = 'choose';
        sizeEl.textContent = text.choose;
        priceEl.textContent = text.fromPrice;
        btnTxt.textContent = text.choose;
        btn.disabled = false;
      } else if (!v.available) {
        state = 'soldout';
        sizeEl.textContent = v.label ? text.size + ' ' + v.label : '';
        priceEl.textContent = v.price;
        btnTxt.textContent = text.soldOut;
        btn.disabled = true;
      } else {
        state = 'add';
        sizeEl.textContent = v.label ? text.size + ' ' + v.label : '';
        priceEl.textContent = v.price;
        btnTxt.textContent = text.add;
        btn.disabled = false;
      }
      bar.dataset.state = state;
    }

    form.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      render(v && v.id ? String(v.id) : currentId());
    });
    render(currentId());

    /* --- Mostrar / esconder ------------------------------------------------ */
    var shown = false;
    function setShown(on) {
      if (on === shown) return;
      shown = on;
      bar.hidden = !on;
      document.documentElement.classList.toggle('sd-sticky-on', on);
      document.documentElement.style.setProperty('--sd-sticky-h', on ? bar.offsetHeight + 'px' : '0px');
    }

    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      /* Solo cuando el botón quedó arriba (ya se pasó), no antes de llegar. */
      setShown(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    /* El alto cambia entre celular y escritorio: se vuelve a medir. */
    window.addEventListener('resize', function () {
      if (shown) document.documentElement.style.setProperty('--sd-sticky-h', bar.offsetHeight + 'px');
    });
    io.observe(mainBtn);

    /* --- Click ---------------------------------------------------------------- */
    btn.addEventListener('click', function () {
      if (state === 'choose') {
        var target = picker || form;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (picker) {
          picker.classList.remove('sd-sticky-flash');
          void picker.offsetWidth;
          picker.classList.add('sd-sticky-flash');
        }
        return;
      }
      if (state !== 'add' || mainBtn.disabled) return;
      bar.classList.add('is-loading');
      btn.disabled = true;
      mainBtn.click();
      setTimeout(function () {
        bar.classList.remove('is-loading');
        render(currentId());
      }, 1200);
    });
  }

  function start() {
    document.querySelectorAll('[data-sd-sticky]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
